export const mainBannerResidenciales = [
  {
    image: '/assets/imgs/services/residenciales/fondo.png',
    color: '#EA0029',
    text: 'SERVICIOS<br/><span>RESIDENCIALES</span>',
  }

];

export const mainBannerResidencialesEn = [
  {
    image: '/assets/imgs/services/residenciales/fondo.png',
    color: '#EA0029',
    text: '<h5>RESIDENTIAL</h5><h3>SERVICES</h3>',
}

];